// Cookie utilities + greeting helper

export function getCookie(name) {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)"),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

// No expires attribute → browser deletes when window closes (session cookie).
export function setSessionCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

// Call this ONCE at login time. First login shows "Hello";
// every later login shows "Welcome back".
export function recordLoginGreeting(email) {
  const key = `bvc_lastLogin_${email || "guest"}`;
  const last = getCookie(key);
  const now = new Date();

  const isWelcomeBack = !!last;
  setSessionCookie("bvc_isWelcomeBack", isWelcomeBack ? "true" : "false");
  setCookie(key, now.toISOString());
}

function sanitizeTitle(rawTitle) {
  const title = String(rawTitle || "").replace(/\./g, " ").trim();
  if (!title) return "";

  const parts = title.split(/\s+/).filter(Boolean);
  const nonDoctorParts = parts.filter((part) => part.toLowerCase() !== "dr");
  const normalizedParts = nonDoctorParts.length > 0 ? nonDoctorParts : parts.slice(0, 1);
  const uniqueParts = normalizedParts.filter(
    (part, index) =>
      normalizedParts.findIndex((item) => item.toLowerCase() === part.toLowerCase()) === index,
  );

  return uniqueParts.join(" ").trim();
}

export function formatDisplayName(user) {
  const title = sanitizeTitle(user?.title);
  const firstName = String(user?.firstname || "").trim();
  const lastName = String(user?.lastname || "").trim();
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();

  if (title && fullName) return `${title} ${fullName}`;
  if (title) return title;
  if (fullName) return fullName;
  return "Doctor";
}

function getGreetingName(userOrFirstName) {
  if (typeof userOrFirstName === "string") {
    return `Dr. ${userOrFirstName || "Doctor"}`.trim();
  }

  const user = userOrFirstName || {};
  const displayName = formatDisplayName(user);
  if (displayName !== "Doctor") return displayName;

  const firstName = String(user.firstname || "").trim();
  return firstName ? `Dr. ${firstName}` : "Doctor";
}

// Read the greeting flag set at login. Stable across dashboard re-renders.
export function getGreeting(userOrFirstName) {
  const name = getGreetingName(userOrFirstName);
  const isWelcomeBack = getCookie("bvc_isWelcomeBack") === "true";
  return isWelcomeBack ? `Welcome back, ${name}!` : `Hello, ${name}!`;
}
